import React from 'react';

const Header = (props) => {
    const { handleClose, empName } = props;
    return (
        <div className='d-flex justify-content-between align-items-center title-container'>
            <div className='title'>{empName}</div>
            <button type='button' className='btn c-gray btn-sm' onClick={handleClose} aria-label='Close'>
                <span>&times;</span>
            </button>
        </div>
    );
};

export default Header;
